import React from "react";
import HeaderMain from "../../fragments/header/HeaderMain";
import {useTranslation} from "react-i18next";
import '../../../styles/HomePage.css';
import Icon from "@mdi/react";
import {mdiAlert, mdiAlertOutline} from "@mdi/js";

const HomePage = () => {
	const {t} = useTranslation();
	return (
		<>
			<div className="mobile-warning">
				<div className="mobile-warning-container">
					<div>
						<Icon path={mdiAlert} size={1.5} style={{margin: "0 0 10px 0"}}/>
						<p>Veuillez utiliser une ordinateur pour accèder à cette application</p>
						<p>Please use a computer to use this application</p>
					</div>
				</div>
			</div>
			<div className="home-page">
				<HeaderMain/>
				<img src="/assets/demo.png" alt="" style={{position: "fixed", top:"60px", right: "90px", height: "70px"}}/>
				<div className="home-page-content">
					<h1 className="home-page-title">
						{t("home_page.carriere")}<br/>{t("home_page.commence")}<span
						className="home-page-highlight">{t("home_page.ici")}.</span>
					</h1>
				</div>
			</div>
		</>
	);
}

export default HomePage;